import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/fluidRenderingParticleDiffuse.fragment.js
var name, shader, fluidRenderingParticleDiffusePixelShader;
var init_fluidRenderingParticleDiffuse_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/fluidRenderingParticleDiffuse.fragment.js"() {
    init_shaderStore();
    name = "fluidRenderingParticleDiffusePixelShader";
    shader = `uniform float particleAlpha;varying vec2 uv;varying vec3 diffuseColor;void main(void) {vec3 normal;normal.xy=uv*2.0-1.0;float r2=dot(normal.xy,normal.xy);if (r2>1.0) discard;glFragColor=vec4(diffuseColor,1.0);}
`;
    ShaderStore.ShadersStore[name] = shader;
    fluidRenderingParticleDiffusePixelShader = { name, shader };
  }
});

export {
  fluidRenderingParticleDiffusePixelShader,
  init_fluidRenderingParticleDiffuse_fragment
};
